import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AdminService } from '../../../services/admin.service';
import { Companies, PostCompany } from '../../../interfaces/admin/Company';
import { ServerResponseObject } from '../../../interfaces/ServerResponse';
import { GetDataService, PostDataService } from '../../../interfaces/DataService';
import { SearchCompanyComponent } from '../../admin/seach-company/search-company.component';

@Component({
  selector: 'app-add-dataservice-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    SearchCompanyComponent
  ],
  templateUrl: './add-dataservice-dialog.component.html',
  styleUrl: './add-dataservice-dialog.component.scss'
})
export class AddDataserviceDialogComponent {
  addDataServiceForm = new FormGroup({
    company_id: new FormControl('', [Validators.required]),
    dataservice_id: new FormControl('', [Validators.required]),
    dataservice_name: new FormControl('', [Validators.required]),
    initialize_ds: new FormControl(false, [Validators.required]),
    data_service_type: new FormControl('', [Validators.required]),
    contact: new FormControl(''),
    phone: new FormControl(''),
    description: new FormControl(''),
    host: new FormControl('bolt://', [Validators.required]),
    port: new FormControl('', [Validators.required]),
    database_name: new FormControl('', [Validators.required]),
    user: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  constructor(private adminService: AdminService) { }

  private readonly dialogRef = inject(MatDialogRef<AddDataserviceDialogComponent>, { optional: true });

  isLoading: boolean = false;

  companyOptions: { id: string; name: string }[] = [];
  private companySearchTimer: any;

  searchLoading: boolean = false;

  onAddDataService() {
    if (!this.addDataServiceForm.valid) return;
    let json = this.addDataServiceForm.value;
    this.isLoading = true;
    this.adminService.addDataService(json as PostDataService).subscribe({
      next: (res: ServerResponseObject<GetDataService>) => {
        this.isLoading = false;
        this.dialogRef?.close(true);
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

}
